<template>
  <div style="min-width: 90%">
    <h1 class="grey--text text--darken-2">Финансы</h1>

    <v-row>
      <v-col cols="1">
        <v-text-field v-model="filters.txID" @change="load()" @click:clear="load()" label="ID" clearable/>
      </v-col>
      <v-col cols="2">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          max-width="290px"
          offset-y>
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeText"
              label="Период"
              readonly
              clearable
              @click:clear="filters.dates=[]; load();"
              v-on="on"/>
          </template>
          <v-date-picker
            v-model="filters.dates"
            :max="new Date().toISOString().substr(0, 10)"
            :reactive="false"
            no-title
            range
            scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu=false">Отмена</v-btn>
            <v-btn text color="primary" @click="menu=false; load()">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col>
        <v-autocomplete v-model="filters.companyID" :items="companies" @change="load()" label="Компания" clearable/>
      </v-col>
      <v-col cols="2">
        <v-autocomplete v-model="filters.daCompanyID" :items="filterDaCompanies" @change="load()" label="Компания DA" clearable/>
      </v-col>
      <v-col cols="1">
        <v-text-field v-model="filters.activityYear" @change="load()" @click:clear="load()" label="Год" clearable/>
      </v-col>
    </v-row>

    <p class="subtitle-1 text-end">
      <v-btn x-small color="green" dark class="float-left" @click="createAction()"><v-icon small>mdi-plus-outline</v-icon>Создать</v-btn>
      <span class="caption">ДЕБЕТ</span> <span class="font-weight-medium red--text text--lighten-1 mr-5">{{ debit.toLocaleString() }} ₴</span>
      <span class="caption">КРЕДИТ</span> <span class="font-weight-medium green--text text--lighten-1 mr-5">{{ credit.toLocaleString() }} ₴</span>
      <span class="caption">САЛЬДО</span> <span class="font-weight-medium mr-5">{{ (credit-debit).toLocaleString() }} ₴</span>
    </p>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      item-key="txID"
      disable-sort
      disable-filtering
      no-data-text="Транзакции отсутствуют"
      dense
      :items-per-page="25"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
        itemsPerPageOptions: [25, 50, 100, -1],
        showFirstLastPage: true
      }"
      class="elevation-1">
      <template v-slot:item.txID="{ item }">
        <span @click="editAction(item)" class="editable" style="cursor: pointer">{{ item.txID }}</span>
      </template>
      <template v-slot:item.txType="{ item }">
        <v-chip x-small :color="item.txType == 'invoice' ? 'red' : 'green'" dark>{{ item.txType }}</v-chip>
      </template>
      <template v-slot:item.txAmount="{ item }">
        <span :class="['invoice'].includes(item.txType) ? 'red--text' : 'green--text text--darken-1'">{{ item.txAmount }}</span>
      </template>
    </v-data-table>

    <FinancesTxDialog ref="financesTxDialog" :companies="companies" :daCompanies="daCompanies" @updated="load()"/>

  </div>
</template>

<script>
import api from '@/api'
import FinancesTxDialog from '@/components/FinancesTxDialog.vue'

export default {
  components: { FinancesTxDialog },
  data: () => ({
    loading: false,
    menu: false,
    filters: {
      dates: [],
      companyID: null,
      daCompanyID: null,
      activityYear: ''
    },
    headers: [
      { text: 'ID', value: 'txID', width: '55px' },
      { text: 'Дата', value: 'txDate', width: '110px', filterable: false },
      { text: 'Тип', value: 'txType', width: '40px', align: 'center', filterable: false },
      { text: 'Сумма', value: 'txAmount', width: '100px', align: 'right', filterable: false },
      { text: 'Компания', value: 'companyName' },
      { text: 'Компания DA', value: 'daCompanyName', filterable: false},
      { text: 'Детали', value: 'txDetails' },
      { text: 'Активность', value: 'activityYear', width: '60px', align: 'center' },
    ],
    companies: [],
    daCompanies: [],
    items: [],
    debit: 0,
    credit: 0
  }),
  computed: {
    dateRangeText: {
      get () { return this.filters.dates.join(' ~ ') },
      set () { }
    },
    filterDaCompanies () {
      let filter = this.daCompanies.map(cur => ({ value: cur[0], text: cur[1] }))
      filter.unshift({value: 0, text: 'Не определена'})
      return filter
    }
  },
  mounted: function () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true;
      api.get('finances/list', {params: this.filters}).then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return;
        this.companies = response.data.data.companies.map(cur => ({ value: cur[0], text: cur[1]}) )
        this.daCompanies = response.data.data.daCompanies
        this.items = response.data.data.items

        this.credit = this.debit = 0

        this.items.forEach(e => e.txType === 'income' ? this.credit += parseFloat(e.txAmount) : this.debit += parseFloat(e.txAmount))
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    createAction () {
      this.$refs.financesTxDialog.create()
    },
    editAction (item) {
      this.$refs.financesTxDialog.edit(item)
    }
  }
}
</script>

<style>
.editable:hover { color: #08A2B8; border-bottom: 1px #08A2B8 dashed; }
.v-list-item { min-height: 30px }
.v-list-item__content { padding: 0; }
.v-list-item__title { font-size: 0.92rem; }
</style>
